import { Add_exports } from "../icons/Add.svg.virtual.js";
import { AddTab_exports } from "../icons/AddTab.svg.virtual.js";
import { Alert_exports } from "../icons/Alert.svg.virtual.js";
import { ArrowLeft_exports } from "../icons/ArrowLeft.svg.virtual.js";
import { ArrowRight_exports } from "../icons/ArrowRight.svg.virtual.js";
import { Brackets_exports } from "../icons/Brackets.svg.virtual.js";
import { Branch_exports } from "../icons/Branch.svg.virtual.js";
import { Changelog_exports } from "../icons/Changelog.svg.virtual.js";
import { Checkmark_exports } from "../icons/Checkmark.svg.virtual.js";
import { ChevronDown_exports } from "../icons/ChevronDown.svg.virtual.js";
import { ChevronLeft_exports } from "../icons/ChevronLeft.svg.virtual.js";
import { ChevronRight_exports } from "../icons/ChevronRight.svg.virtual.js";
import { ChevronUp_exports } from "../icons/ChevronUp.svg.virtual.js";
import { Clipboard_exports } from "../icons/Clipboard.svg.virtual.js";
import { Close_exports } from "../icons/Close.svg.virtual.js";
import { CloseTab_exports } from "../icons/CloseTab.svg.virtual.js";
import { CloseTabs_exports } from "../icons/CloseTabs.svg.virtual.js";
import { Cloud_exports } from "../icons/Cloud.svg.virtual.js";
import { CodeFolder_exports } from "../icons/CodeFolder.svg.virtual.js";
import { Cog_exports } from "../icons/Cog.svg.virtual.js";
import { Collection_exports } from "../icons/Collection.svg.virtual.js";
import { Cookie_exports } from "../icons/Cookie.svg.virtual.js";
import { DarkMode_exports } from "../icons/DarkMode.svg.virtual.js";
import { Delete_exports } from "../icons/Delete.svg.virtual.js";
import { Discord_exports } from "../icons/Discord.svg.virtual.js";
import { DocsPage_exports } from "../icons/DocsPage.svg.virtual.js";
import { Download_exports } from "../icons/Download.svg.virtual.js";
import { Duplicate_exports } from "../icons/Duplicate.svg.virtual.js";
import { Edit_exports } from "../icons/Edit.svg.virtual.js";
import { Ellipses_exports } from "../icons/Ellipses.svg.virtual.js";
import { Email_exports } from "../icons/Email.svg.virtual.js";
import { Error_exports } from "../icons/Error.svg.virtual.js";
import { Example_exports } from "../icons/Example.svg.virtual.js";
import { ExternalLink_exports } from "../icons/ExternalLink.svg.virtual.js";
import { FilterList_exports } from "../icons/FilterList.svg.virtual.js";
import { Folder_exports } from "../icons/Folder.svg.virtual.js";
import { GitHub_exports } from "../icons/GitHub.svg.virtual.js";
import { GitHubLine_exports } from "../icons/GitHubLine.svg.virtual.js";
import { Globe_exports } from "../icons/Globe.svg.virtual.js";
import { Google_exports } from "../icons/Google.svg.virtual.js";
import { Help_exports } from "../icons/Help.svg.virtual.js";
import { Hide_exports } from "../icons/Hide.svg.virtual.js";
import { History_exports } from "../icons/History.svg.virtual.js";
import { House_exports } from "../icons/House.svg.virtual.js";
import { Import_exports } from "../icons/Import.svg.virtual.js";
import { Info_exports } from "../icons/Info.svg.virtual.js";
import { Key_exports } from "../icons/Key.svg.virtual.js";
import { Leave_exports } from "../icons/Leave.svg.virtual.js";
import { LightDarkModeToggle_exports } from "../icons/LightDarkModeToggle.svg.virtual.js";
import { LightMode_exports } from "../icons/LightMode.svg.virtual.js";
import { Link_exports } from "../icons/Link.svg.virtual.js";
import { Lock_exports } from "../icons/Lock.svg.virtual.js";
import { Logo_exports } from "../icons/Logo.svg.virtual.js";
import { Magic_exports } from "../icons/Magic.svg.virtual.js";
import { Markdown_exports } from "../icons/Markdown.svg.virtual.js";
import { Menu_exports } from "../icons/Menu.svg.virtual.js";
import { NotAllowed_exports } from "../icons/NotAllowed.svg.virtual.js";
import { Page_exports } from "../icons/Page.svg.virtual.js";
import { Pencil_exports } from "../icons/Pencil.svg.virtual.js";
import { Play_exports } from "../icons/Play.svg.virtual.js";
import { Refresh_exports } from "../icons/Refresh.svg.virtual.js";
import { Roadmap_exports } from "../icons/Roadmap.svg.virtual.js";
import { Scribble_exports } from "../icons/Scribble.svg.virtual.js";
import { Search_exports } from "../icons/Search.svg.virtual.js";
import { Server_exports } from "../icons/Server.svg.virtual.js";
import { Settings_exports } from "../icons/Settings.svg.virtual.js";
import { Show_exports } from "../icons/Show.svg.virtual.js";
import { Sort_exports } from "../icons/Sort.svg.virtual.js";
import { Terminal_exports } from "../icons/Terminal.svg.virtual.js";
import { Trash_exports } from "../icons/Trash.svg.virtual.js";
import { Unlock_exports } from "../icons/Unlock.svg.virtual.js";
import { Unwatch_exports } from "../icons/Unwatch.svg.virtual.js";
import { Upload_exports } from "../icons/Upload.svg.virtual.js";
import { User_exports } from "../icons/User.svg.virtual.js";
import { UserSwitch_exports } from "../icons/UserSwitch.svg.virtual.js";
import { Users_exports } from "../icons/Users.svg.virtual.js";
import { Versions_exports } from "../icons/Versions.svg.virtual.js";
import { Wallet_exports } from "../icons/Wallet.svg.virtual.js";
import { Watch_exports } from "../icons/Watch.svg.virtual.js";
import { Workspace_exports } from "../icons/Workspace.svg.virtual.js";
import { programming_framework_angular_exports } from "../icons/programming-framework-angular.svg.virtual.js";
import { programming_framework_astro_exports } from "../icons/programming-framework-astro.svg.virtual.js";
import { programming_framework_laravel_exports } from "../icons/programming-framework-laravel.svg.virtual.js";
import { programming_framework_nextdotjs_exports } from "../icons/programming-framework-nextdotjs.svg.virtual.js";
import { programming_framework_react_exports } from "../icons/programming-framework-react.svg.virtual.js";
import { programming_framework_vuedotjs_exports } from "../icons/programming-framework-vuedotjs.svg.virtual.js";
import { programming_language_c_exports } from "../icons/programming-language-c.svg.virtual.js";
import { programming_language_clojure_exports } from "../icons/programming-language-clojure.svg.virtual.js";
import { programming_language_csharp_exports } from "../icons/programming-language-csharp.svg.virtual.js";
import { programming_language_css3_exports } from "../icons/programming-language-css3.svg.virtual.js";
import { programming_language_dart_exports } from "../icons/programming-language-dart.svg.virtual.js";
import { programming_language_fsharp_exports } from "../icons/programming-language-fsharp.svg.virtual.js";
import { programming_language_go_exports } from "../icons/programming-language-go.svg.virtual.js";
import { programming_language_html5_exports } from "../icons/programming-language-html5.svg.virtual.js";
import { programming_language_http_exports } from "../icons/programming-language-http.svg.virtual.js";
import { programming_language_java_exports } from "../icons/programming-language-java.svg.virtual.js";
import { programming_language_javascript_exports } from "../icons/programming-language-javascript.svg.virtual.js";
import { programming_language_json_exports } from "../icons/programming-language-json.svg.virtual.js";
import { programming_language_julia_exports } from "../icons/programming-language-julia.svg.virtual.js";
import { programming_language_kotlin_exports } from "../icons/programming-language-kotlin.svg.virtual.js";
import { programming_language_node_exports } from "../icons/programming-language-node.svg.virtual.js";
import { programming_language_objc_exports } from "../icons/programming-language-objc.svg.virtual.js";
import { programming_language_ocaml_exports } from "../icons/programming-language-ocaml.svg.virtual.js";
import { programming_language_php_exports } from "../icons/programming-language-php.svg.virtual.js";
import { programming_language_powershell_exports } from "../icons/programming-language-powershell.svg.virtual.js";
import { programming_language_python_exports } from "../icons/programming-language-python.svg.virtual.js";
import { programming_language_r_exports } from "../icons/programming-language-r.svg.virtual.js";
import { programming_language_ruby_exports } from "../icons/programming-language-ruby.svg.virtual.js";
import { programming_language_rust_exports } from "../icons/programming-language-rust.svg.virtual.js";
import { programming_language_scala_exports } from "../icons/programming-language-scala.svg.virtual.js";
import { programming_language_shell_exports } from "../icons/programming-language-shell.svg.virtual.js";
import { programming_language_swift_exports } from "../icons/programming-language-swift.svg.virtual.js";
import { programming_language_typescript_exports } from "../icons/programming-language-typescript.svg.virtual.js";
import { programming_script_code_exports } from "../icons/programming-script-code.svg.virtual.js";
import { programming_tool_git_exports } from "../icons/programming-tool-git.svg.virtual.js";
import { programming_tool_tailwindcss_exports } from "../icons/programming-tool-tailwindcss.svg.virtual.js";
import { Adonisjs_exports } from "../logos/Adonisjs.svg.virtual.js";
import { Astro_exports } from "../logos/Astro.svg.virtual.js";
import { Docusaurus_exports } from "../logos/Docusaurus.svg.virtual.js";
import { Dotnet_exports } from "../logos/Dotnet.svg.virtual.js";
import { Elysiajs_exports } from "../logos/Elysiajs.svg.virtual.js";
import { Express_exports } from "../logos/Express.svg.virtual.js";
import { Fastapi_exports } from "../logos/Fastapi.svg.virtual.js";
import { Fastify_exports } from "../logos/Fastify.svg.virtual.js";
import { Go_exports } from "../logos/Go.svg.virtual.js";
import { Hono_exports } from "../logos/Hono.svg.virtual.js";
import { Laravel_exports } from "../logos/Laravel.svg.virtual.js";
import { Litestar_exports } from "../logos/Litestar.svg.virtual.js";
import { Nestjs_exports } from "../logos/Nestjs.svg.virtual.js";
import { Nextjs_exports } from "../logos/Nextjs.svg.virtual.js";
import { Nitro_exports } from "../logos/Nitro.svg.virtual.js";
import { Nuxt_exports } from "../logos/Nuxt.svg.virtual.js";
import { Openapi_exports } from "../logos/Openapi.svg.virtual.js";
import { Platformatic_exports } from "../logos/Platformatic.svg.virtual.js";
import { React_exports } from "../logos/React.svg.virtual.js";
import { Rust_exports } from "../logos/Rust.svg.virtual.js";
import { Svelte_exports } from "../logos/Svelte.svg.virtual.js";
import { Vue_exports } from "../logos/Vue.svg.virtual.js";
//#region src/components/ScalarIcon/utils/index.ts
var icons = /* #__PURE__ */ Object.assign({
	"../icons/Add.svg": Add_exports,
	"../icons/AddTab.svg": AddTab_exports,
	"../icons/Alert.svg": Alert_exports,
	"../icons/ArrowLeft.svg": ArrowLeft_exports,
	"../icons/ArrowRight.svg": ArrowRight_exports,
	"../icons/Brackets.svg": Brackets_exports,
	"../icons/Branch.svg": Branch_exports,
	"../icons/Changelog.svg": Changelog_exports,
	"../icons/Checkmark.svg": Checkmark_exports,
	"../icons/ChevronDown.svg": ChevronDown_exports,
	"../icons/ChevronLeft.svg": ChevronLeft_exports,
	"../icons/ChevronRight.svg": ChevronRight_exports,
	"../icons/ChevronUp.svg": ChevronUp_exports,
	"../icons/Clipboard.svg": Clipboard_exports,
	"../icons/Close.svg": Close_exports,
	"../icons/CloseTab.svg": CloseTab_exports,
	"../icons/CloseTabs.svg": CloseTabs_exports,
	"../icons/Cloud.svg": Cloud_exports,
	"../icons/CodeFolder.svg": CodeFolder_exports,
	"../icons/Cog.svg": Cog_exports,
	"../icons/Collection.svg": Collection_exports,
	"../icons/Cookie.svg": Cookie_exports,
	"../icons/DarkMode.svg": DarkMode_exports,
	"../icons/Delete.svg": Delete_exports,
	"../icons/Discord.svg": Discord_exports,
	"../icons/DocsPage.svg": DocsPage_exports,
	"../icons/Download.svg": Download_exports,
	"../icons/Duplicate.svg": Duplicate_exports,
	"../icons/Edit.svg": Edit_exports,
	"../icons/Ellipses.svg": Ellipses_exports,
	"../icons/Email.svg": Email_exports,
	"../icons/Error.svg": Error_exports,
	"../icons/Example.svg": Example_exports,
	"../icons/ExternalLink.svg": ExternalLink_exports,
	"../icons/FilterList.svg": FilterList_exports,
	"../icons/Folder.svg": Folder_exports,
	"../icons/GitHub.svg": GitHub_exports,
	"../icons/GitHubLine.svg": GitHubLine_exports,
	"../icons/Globe.svg": Globe_exports,
	"../icons/Google.svg": Google_exports,
	"../icons/Help.svg": Help_exports,
	"../icons/Hide.svg": Hide_exports,
	"../icons/History.svg": History_exports,
	"../icons/House.svg": House_exports,
	"../icons/Import.svg": Import_exports,
	"../icons/Info.svg": Info_exports,
	"../icons/Key.svg": Key_exports,
	"../icons/Leave.svg": Leave_exports,
	"../icons/LightDarkModeToggle.svg": LightDarkModeToggle_exports,
	"../icons/LightMode.svg": LightMode_exports,
	"../icons/Link.svg": Link_exports,
	"../icons/Lock.svg": Lock_exports,
	"../icons/Logo.svg": Logo_exports,
	"../icons/Magic.svg": Magic_exports,
	"../icons/Markdown.svg": Markdown_exports,
	"../icons/Menu.svg": Menu_exports,
	"../icons/NotAllowed.svg": NotAllowed_exports,
	"../icons/Page.svg": Page_exports,
	"../icons/Pencil.svg": Pencil_exports,
	"../icons/Play.svg": Play_exports,
	"../icons/Refresh.svg": Refresh_exports,
	"../icons/Roadmap.svg": Roadmap_exports,
	"../icons/Scribble.svg": Scribble_exports,
	"../icons/Search.svg": Search_exports,
	"../icons/Server.svg": Server_exports,
	"../icons/Settings.svg": Settings_exports,
	"../icons/Show.svg": Show_exports,
	"../icons/Sort.svg": Sort_exports,
	"../icons/Terminal.svg": Terminal_exports,
	"../icons/Trash.svg": Trash_exports,
	"../icons/Unlock.svg": Unlock_exports,
	"../icons/Unwatch.svg": Unwatch_exports,
	"../icons/Upload.svg": Upload_exports,
	"../icons/User.svg": User_exports,
	"../icons/UserSwitch.svg": UserSwitch_exports,
	"../icons/Users.svg": Users_exports,
	"../icons/Versions.svg": Versions_exports,
	"../icons/Wallet.svg": Wallet_exports,
	"../icons/Watch.svg": Watch_exports,
	"../icons/Workspace.svg": Workspace_exports,
	"../icons/programming-framework-angular.svg": programming_framework_angular_exports,
	"../icons/programming-framework-astro.svg": programming_framework_astro_exports,
	"../icons/programming-framework-laravel.svg": programming_framework_laravel_exports,
	"../icons/programming-framework-nextdotjs.svg": programming_framework_nextdotjs_exports,
	"../icons/programming-framework-react.svg": programming_framework_react_exports,
	"../icons/programming-framework-vuedotjs.svg": programming_framework_vuedotjs_exports,
	"../icons/programming-language-c.svg": programming_language_c_exports,
	"../icons/programming-language-clojure.svg": programming_language_clojure_exports,
	"../icons/programming-language-csharp.svg": programming_language_csharp_exports,
	"../icons/programming-language-css3.svg": programming_language_css3_exports,
	"../icons/programming-language-dart.svg": programming_language_dart_exports,
	"../icons/programming-language-fsharp.svg": programming_language_fsharp_exports,
	"../icons/programming-language-go.svg": programming_language_go_exports,
	"../icons/programming-language-html5.svg": programming_language_html5_exports,
	"../icons/programming-language-http.svg": programming_language_http_exports,
	"../icons/programming-language-java.svg": programming_language_java_exports,
	"../icons/programming-language-javascript.svg": programming_language_javascript_exports,
	"../icons/programming-language-json.svg": programming_language_json_exports,
	"../icons/programming-language-julia.svg": programming_language_julia_exports,
	"../icons/programming-language-kotlin.svg": programming_language_kotlin_exports,
	"../icons/programming-language-node.svg": programming_language_node_exports,
	"../icons/programming-language-objc.svg": programming_language_objc_exports,
	"../icons/programming-language-ocaml.svg": programming_language_ocaml_exports,
	"../icons/programming-language-php.svg": programming_language_php_exports,
	"../icons/programming-language-powershell.svg": programming_language_powershell_exports,
	"../icons/programming-language-python.svg": programming_language_python_exports,
	"../icons/programming-language-r.svg": programming_language_r_exports,
	"../icons/programming-language-ruby.svg": programming_language_ruby_exports,
	"../icons/programming-language-rust.svg": programming_language_rust_exports,
	"../icons/programming-language-scala.svg": programming_language_scala_exports,
	"../icons/programming-language-shell.svg": programming_language_shell_exports,
	"../icons/programming-language-swift.svg": programming_language_swift_exports,
	"../icons/programming-language-typescript.svg": programming_language_typescript_exports,
	"../icons/programming-script-code.svg": programming_script_code_exports,
	"../icons/programming-tool-git.svg": programming_tool_git_exports,
	"../icons/programming-tool-tailwindcss.svg": programming_tool_tailwindcss_exports
});
var logos = /* #__PURE__ */ Object.assign({
	"../logos/Adonisjs.svg": Adonisjs_exports,
	"../logos/Astro.svg": Astro_exports,
	"../logos/Docusaurus.svg": Docusaurus_exports,
	"../logos/Dotnet.svg": Dotnet_exports,
	"../logos/Elysiajs.svg": Elysiajs_exports,
	"../logos/Express.svg": Express_exports,
	"../logos/Fastapi.svg": Fastapi_exports,
	"../logos/Fastify.svg": Fastify_exports,
	"../logos/Go.svg": Go_exports,
	"../logos/Hono.svg": Hono_exports,
	"../logos/Laravel.svg": Laravel_exports,
	"../logos/Litestar.svg": Litestar_exports,
	"../logos/Nestjs.svg": Nestjs_exports,
	"../logos/Nextjs.svg": Nextjs_exports,
	"../logos/Nitro.svg": Nitro_exports,
	"../logos/Nuxt.svg": Nuxt_exports,
	"../logos/Openapi.svg": Openapi_exports,
	"../logos/Platformatic.svg": Platformatic_exports,
	"../logos/React.svg": React_exports,
	"../logos/Rust.svg": Rust_exports,
	"../logos/Svelte.svg": Svelte_exports,
	"../logos/Vue.svg": Vue_exports
});
/**
* Generate a Vue component from the icon SVGs
*
* For any changes to this file, please ensure it works with SSR
*/
var getIcon = (name) => {
	const filename = `../icons/${name}.svg`;
	if (!icons[filename]) {
		console.warn(`Could not find icon: ${name}`);
		return null;
	}
	return icons[filename];
};
/**
* Generate a Vue component from the logo SVGs
*
* For any changes to this file, please ensure it works with SSR
*/
var getLogo = (name) => {
	const filename = `../logos/${name}.svg`;
	if (!logos[filename]) {
		console.warn(`Could not find icon: ${name}`);
		return null;
	}
	return logos[filename];
};
//#endregion
export { getIcon, getLogo };

//# sourceMappingURL=index.js.map